import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

import SdxAccordion from 'sdx/accordion/Accordion';
import SdxInputField from 'sdx/form/InputField';
import SdxSelect from 'sdx/form/Select';
import SdxTable from 'sdx/table/Table';

import DomElement from 'sdx/DomElement';

interface Initializer {
	test($el : JQuery) : boolean;
	init(el : HTMLElement) : DomElement;
}

/**
 * Initializes SDX components automatically if they’re in the whitelist.
 * Replacement for data-init="auto", which would require the portal
 * to include the whole SDX JS code.
 */
export default class SDXAutoInit extends Module {
	public static INITIALIZERS : Initializer[] = [
		{
			test($el) {
				return $el.is('input');
			},
			init(el) {
				return new SdxInputField(el as HTMLInputElement);
			},
		},
		{
			test($el) {
				return $el.is('select');
			},
			init(el) {
				const select =  new SdxSelect(el as HTMLSelectElement);
				select.element.parentElement?.querySelectorAll('.dropdown-item').forEach(e => {
					e.innerHTML = e.innerHTML.replace(/amp;/gi, '');
				});

				return select;
			},
		},
		{
			test($el) {
				return $el.is('.accordion');
			},
			init(el) {
				return new SdxAccordion(el);
			},
		},
		{
			test($el) {
				return $el.is('table');
			},
			init(el) {
				return new SdxTable(el as HTMLTableElement);
			},
		},
	];

	public instance? : DomElement;
	public on(callback : Hook) {
		this.log('doing nothing until after');
		callback();
	}
	public after() {
		this.instance = this.init();
	}

	private init() {
		for(const initializer of SDXAutoInit.INITIALIZERS) {
			if(initializer.test(this.$ctx)) {
				return initializer.init(this.$ctx[0]);
			}
		}

		return undefined;
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/Tc.Module.SDXAutoInit.ts